import React from 'react';
import { I18nText as I18n } from '@gloat/glocalize';
import Skeleton from '../../components/skeleton';
import { H4 } from '../../components/title';
import { TagGroup } from '../../components/group';
import Button from '../../components/button';
import ScrollableContainer from '../../components/scrollable-container';
import Tag from '../../components/tag';
import Spinner from '../../components/spinner';

export const SuggestionsGroup = ({
  onAdd,
  suggestions,
  isInitialLoading,
  heading,
  disabled,
  suggestionsMaxHeight,
  renderSuggestionTag,
  isFetching,
}: {
  onAdd?: (suggestion: any) => void;
  isInitialLoading?: boolean;
  suggestions?: { [key: string]: any }[];
  disabled?: boolean;
  isLoading?: boolean;
  isFetching?: boolean;
  heading?: string | React.ReactElement;
  suggestionsMaxHeight?: number;
  renderSuggestionTag?: ({
    item,
    getButtonProps,
  }: {
    item: { [key: string]: any };
    getButtonProps: () => {
      disabled?: boolean;
      onClick: () => void;
    };
  }) => React.JSX.Element;
}) => {
  return (
    <>
      {isInitialLoading && (suggestions?.length === 0 || !suggestions) ? (
        <React.Fragment>
          <Skeleton active>
            <H4 weight={500} display={'inline-block'} marginBottom={'sm'}>
              {heading || <I18n id={'AUTOCOMPLETE_SUGGESTIONS_LABEL'} />}
            </H4>
          </Skeleton>
          <TagGroup aria-label="suggestion actions">
            {new Array(3).fill(null).map((val, index) => (
              <Skeleton active key={index}>
                <Button size={'md'} variant={'secondary'}>
                  suggest
                </Button>
              </Skeleton>
            ))}
          </TagGroup>
        </React.Fragment>
      ) : (
        Number(suggestions?.length) > 0 && (
          <React.Fragment>
            <H4 weight={500} display={'inline-block'} marginBottom={'sm'} size={'sm'}>
              {heading || <I18n id={'AUTOCOMPLETE_SUGGESTIONS_LABEL'} />}
            </H4>
            <ScrollableContainer maxHeight={suggestionsMaxHeight}>
              <TagGroup alignItems={'center'} aria-label="suggestion actions">
                {suggestions?.map?.((suggestion, index) => {
                  const onClick = () => {
                    onAdd?.(suggestion);
                  };

                  return renderSuggestionTag ? (
                    renderSuggestionTag({
                      item: suggestion,
                      getButtonProps: () => ({
                        disabled,
                        onClick,
                      }),
                    })
                  ) : (
                    <Tag size={'lg'} key={suggestion.id || index} height={'auto'}>
                      <Tag.Text maxWidth={200}>{suggestion.name}</Tag.Text>
                      <Tag.ActionIcon
                        aria-label={`Add ${suggestion.name}`}
                        onClick={onClick}
                        data-testid={'add-suggestion-button'}
                        data-id={`${suggestion.id || index}`}
                        disabled={disabled}
                        icon={'PLUS'}
                        variant={'action'}
                      />
                    </Tag>
                  );
                })}
                {isFetching && <Spinner size={'xs'} />}
              </TagGroup>
            </ScrollableContainer>
          </React.Fragment>
        )
      )}
    </>
  );
};
